import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/smb-logo.png';
import { UserOutlined, LogoutOutlined, SettingOutlined, UsergroupAddOutlined, LockOutlined, HomeOutlined } from '@ant-design/icons';
import { Layout, Dropdown, Button, Menu, Tooltip } from 'antd';
import { jwtDecode } from 'jwt-decode';
const { Header } = Layout;


function HeaderApp ({ setAuthToken }) {

    const [username, setUsername] = useState("no-username");
    const navigate = useNavigate();

    const itemsMenuAdmin = [{
        label: 'Config. usuarios',
        key: 'users',
        icon: <UsergroupAddOutlined />,
    },{
        label: 'Config. perfiles',
        key: 'profiles',
        icon: <LockOutlined />,
    },{
        label: 'Config. autorización',
        key: 'settAuth',
        icon: <SettingOutlined />,
    },{
        label: 'Cerrar sesión',
        key: 'logout',
        icon: <LogoutOutlined />,
    }];

    const itemsMenuUsuario = [{
        label: 'Cerrar sesión',
        key: 'logout',
        icon: <LogoutOutlined />,
    }];

    useEffect(() => {
        const decoded = jwtDecode(localStorage.getItem("token"));
        if (decoded && decoded.rol_id) {
            setUsername(decoded.usuario.toUpperCase());
        }
    }, []);

    const onClick = (e) => {
        if (e && e.key === "logout") handleLogout();
        if (e && e.key === "settAuth") Navigate("/settings-auth");
        if (e && e.key === "users") Navigate("/users");
        if (e && e.key === "profiles") Navigate("/profiles");
    };

    const Navigate = (path) => {
        navigate(path);
    }

    const handleLogout = () => {
        localStorage.removeItem('token');
        setAuthToken(null);
        navigate('/login')
    };

    const menu = (
        <Menu onClick={onClick} items={jwtDecode(localStorage.getItem("token")).rol_id === 1?itemsMenuAdmin:itemsMenuUsuario}></Menu>
    );

    return (
        <Header
        className='header-app'>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <img src={logo} alt="SMB Logo" style={{ height: '60px', objectFit: 'contain' }} />
                <Tooltip title="Ir al inicio">
                    <Button
                        type="text"
                        icon={<HomeOutlined style={{ fontSize: 20 }} />}
                        onClick={() => navigate('/home')}
                        style={{ color: '#1890ff' }}
                    />
                </Tooltip>
            </div>

            {/* Menú de usuario en el lado derecho */}
            <div style={{ float: 'right' }}>
                <Dropdown overlay={menu} trigger={['click']}>
                    <Button type="text" icon={<UserOutlined />}>
                    Hola, {username}
                    </Button>
                </Dropdown>
            </div>
        </Header>
    )
}

export default HeaderApp;